var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",style:({ background: _vm.lightColor(_vm.color) })},[_c('p',{style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }